module.exports = __webpack_public_path__ + "img/57.1583b765.jpg";